import { getStoreAddress } from "@grandvisionhq/analytics";
import { DateUtils } from "@grandvisionhq/utils";
const getExtraDataEvent = (data) => {
  const { appointment, store } = data ?? {};
  return {
    appointment: {
      type_of_appointment: appointment ? getTypeOfAppointment(appointment) : "",
      type_of_service: appointment?.appointmentType.id ?? "",
      age_range: appointment ? getAgeRangeLabel(appointment.appointmentType.ageGroup) : ""
    },
    store: {
      id: store?.globalStoreId ?? "",
      name: store?.name ?? "",
      address: store ? getStoreAddress({ ...store, city: store.town ?? "" }) : "",
      postalCode: store?.postalCode ?? "",
      city: store?.town ?? ""
    },
    time: {
      startTime: appointment?.startTime ? DateUtils.toLocalDateTimeTimeZone(appointment.startTime) : "",
      endTime: appointment?.endTime ? DateUtils.toLocalDateTimeTimeZone(appointment.endTime) : ""
    },
    ...appointment?.id ? { appointmentId: { id: appointment.id } } : {}
  };
};
const getTypeOfAppointment = (appointment) => appointment.appointmentType.isVirtualAppointment ? "videocall" : "onsite";
const getStoreDetails = (storeDetails) => {
  const { city, country, id, name, postalCode } = storeDetails;
  return {
    city,
    country,
    id,
    name,
    postalCode,
    address: getStoreAddress(storeDetails)
  };
};
const getStoreDetailsWithoutCountry = (storeDetails) => {
  const { city, id, name, postalCode } = storeDetails;
  return {
    city,
    id,
    name,
    postalCode,
    address: getStoreAddress(storeDetails)
  };
};
const getAgeRangeLabel = (ageGroup) => {
  if (ageGroup === "CHILD") {
    return "child appointment";
  }
  if (ageGroup === "ADULT") {
    return "adult";
  }
  if (ageGroup === "SENIOR") {
    return "senior";
  }
  return "";
};
const getStoreDetailsWithStock = (storeDetails) => {
  const {
    town: city,
    country,
    code,
    name,
    postalCode,
    additionalStreetInfo,
    streetName,
    streetNumber
  } = storeDetails;
  const storeAddressProperties = {
    city,
    additionalStreetInfo: additionalStreetInfo ?? "",
    streetName,
    streetNumber: streetNumber ?? ""
  };
  return {
    city: city.toLowerCase(),
    country,
    id: code.toString().toLowerCase(),
    name: name.toLowerCase(),
    postalCode,
    address: getStoreAddress(storeAddressProperties).toLowerCase(),
    stock: ""
  };
};
export {
  getAgeRangeLabel,
  getExtraDataEvent,
  getStoreDetails,
  getStoreDetailsWithStock,
  getStoreDetailsWithoutCountry
};
//# sourceMappingURL=utils.js.map
